// extracted by mini-css-extract-plugin
export default {"storyDetail":"c-e_bA","storyDetail__photo":"c-e_bB"};